module.exports = __webpack_public_path__ + "img/brandsgp.a4b7add2.jpg";